import ModalActionsProvider from './hooks/useModalActions';

import { ModalActionsCloseProps, ModalActionsProps } from './@types/ModalActionsProps';
import { useHandleModal } from '../ModalTrigger/hooks/useHandleModal';

const ModalActions = (props: ModalActionsProps) => <ModalActionsProvider {...props}></ModalActionsProvider>;

export const ModalActionsClose = (props: ModalActionsCloseProps) => {
	const handleModal = useHandleModal();

	return (
		<button
			data-selection={props.componentId}
			className={`closeButton closeButton--${props.blockClass} bw1 fw5 ba v-mid pa0 lh-solid br2 pointer bg-action-secondary b--action-secondary c-on-action-secondary hover-bg-action-secondary hover-b--action-secondary hover-c-on-action-secondary min-h-regular t-action`}
		>
			<span
				role="button"
				onClick={() => handleModal?.toggleModal()}
				className={`closeButtonLabel closeButtonLabel--${props.blockClass} w-100 tc ph6`}
			>
				{props.label ?? 'Cancelar'}
			</span>
		</button>
	);
};

export default ModalActions;
